
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Message } from "@/types/message";
import { formatMessagesForPdf } from "./messageProcessor";

/**
 * Adds the conversation message table to the PDF
 */
export const addMessageTable = (
  doc: jsPDF,
  messages: Message[],
  userFullName: string,
  merchantName: string,
  startY: number
): number => {
  // Add conversation history title
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text("Conversation History:", 14, startY);
  
  // Format message content for the table
  const messageRows = formatMessagesForPdf(messages, userFullName, merchantName);
  
  // Add the messages to the PDF as a table
  autoTable(doc, {
    startY: startY + 5,
    head: [["Date", "From", "Message"]],
    body: messageRows,
    headStyles: {
      fillColor: [240, 240, 240],
      textColor: [0, 0, 0],
      fontStyle: "bold",
    },
    columnStyles: {
      0: { cellWidth: 30 },
      1: { cellWidth: 30 },
      2: { cellWidth: "auto" }
    },
    styles: {
      overflow: "linebreak",
      cellPadding: 4,
      fontSize: 9,
    },
    willDrawCell: (data) => {
      // Add alternating row colors for better readability
      if (data.section === "body" && data.row.index % 2 === 0) {
        doc.setFillColor(248, 248, 248);
      } else {
        doc.setFillColor(255, 255, 255);
      }
    }
  });
  
  // Return the final Y position for footer placement
  return (doc as any).lastAutoTable.finalY || 280;
};
